import m from 'mithril';

import { Type } from '../components/Typography';

const paragraphClass = 'terms-page__paragraph';

/**
 * Terms of service page.
 */
export const Terms: m.Component = {
  view: () => {
    return m('section', { class: 'page terms-page' }, [
      m(Type, { size: 'title' }, 'MeshOS Inc. Terms of Service'),
      m('div', { class: 'terms-page__body' }, [
        m(Type, { className: paragraphClass }, m('strong', 'Last Updated: December 18, 2023')),
        m(Type, { className: paragraphClass },
          'If you signed a separate Cover Page to access the Product with the same account, and that agreement has not ended, the terms below do not apply to you. Instead, your separate Cover Page applies to your use of the Product.'),
        m(Type, { className: paragraphClass }, [
          'This Agreement is between MeshOS Inc. and the company or person accessing or using the Product. This Agreement consists of: (1) the Order Form and (2) the Key Terms, both of which are on the Cover Page below, and (3) the Common Paper ',
          m('a', {
            href: 'https://commonpaper.com/standards/cloud-service-agreement/1.0/',
            target: '_blank',
            rel: 'noreferrer',
          }, 'Cloud Service Agreement Standard Terms Version 1.0'),
          ' ("Standard Terms").',
        ]),
        m(Type, { className: paragraphClass },
          'Any modifications to the Standard Terms made in the Cover Page will control over conflicts with the Standard Terms. Capitalized words have the meanings or descriptions given in the Cover Page or the Standard Terms.'),
        m(Type, { className: paragraphClass },
          'If you are accessing or using the Product on behalf of your company, you represent that you are authorized to accept this Agreement on behalf of your company. By signing up, accessing, or using the Product, Customer indicates its acceptance of this Agreement and agrees to be bound by the terms and conditions of this Agreement.'),
        m(Type, { size: 'subtitle', className: paragraphClass }, 'Cover Page'),
        m(Type, { className: paragraphClass }, m('em', 'Order Form')),
        m(Type, { className: paragraphClass }, [
          m('strong', 'Cloud Service:'),
          ' MeshOS is a desktop application backed by cloud services that gives users persistent working context, in large collaborative workspaces.',
        ]),
        m(Type, { className: paragraphClass }, [m('strong', 'Subscription Start Date:'), ' The Effective Date']),
        m(Type, { className: paragraphClass }, [m('strong', 'Subscription Period:'), ' 1 month(s)']),
        m(Type, { className: paragraphClass }, [m('strong', 'Non-Renewal Notice Period:'), ' At least 30 days before the end of the current Subscription Period.']),
        m(Type, { className: paragraphClass }, [m('strong', 'Use Limitations:'), ' Maximum number of workspaces per account is 1000. Maximum number of elements per workspace is 256.']),
        m(Type, { className: paragraphClass }, [
          m('strong', 'Professional Services:'),
          ' Contact us for development of workspaces, custom modules, and additional features, at ',
          m('a', { href: 'mailto:team@meshos.com' }, 'team@meshos.com'),
        ]),
        m(Type, { className: paragraphClass }, m('em', 'Key Terms')),
        m(Type, { className: paragraphClass }, [m('strong', 'Customer:'), ' The company or person who accesses or uses the Product. If the person accepting this Agreement is doing so on behalf of a company, all use of the word "Customer" in the Agreement will mean that company.']),
        m(Type, { className: paragraphClass }, [m('strong', 'Provider:'), ' MeshOS Inc.']),
        m(Type, { className: paragraphClass }, [m('strong', 'Effective Date:'), ' The date Customer first accepts this Agreement.']),
        m(Type, { className: paragraphClass }, m('strong', 'Covered Claims:')),
        m(Type, { className: paragraphClass }, [m('strong', 'Provider Covered Claims:'), ' Any action, proceeding, or claim that the Cloud Service, when used by Customer according to the terms of the Agreement, violates, misappropriates, or otherwise infringes upon anyone else\'s intellectual property or other proprietary rights.']),
        m(Type, { className: paragraphClass }, [m('strong', 'Customer Covered Claims:'), ' Any action, proceeding, or claim that (1) the Customer Content, when used according to the terms of the Agreement, violates, misappropriates, or otherwise infringes upon anyone else\'s intellectual property or other proprietary rights; or (2) results from Customer\'s breach or alleged breach of Section 2.1 (Restrictions on Customer).']),
        m(Type, { className: paragraphClass }, [m('strong', 'General Cap Amount:'), ' The fees paid or payable by Customer to provider in the 12 month period immediately before the claim']),
        m(Type, { className: paragraphClass }, [m('strong', 'Governing Law:'), ' The laws of the State of Delaware']),
        m(Type, { className: paragraphClass }, [m('strong', 'Chosen Courts:'), ' The state or federal courts located in Delaware']),
        m(Type, { className: paragraphClass }, [
          m('strong', 'Notice Address:'),
          m('br'),
          'For Provider: team@meshos.com',
          m('br'),
          "For Customer: The main email address on Customer's Account",
        ]),
      ]),
    ]);
  },
};
